<template>
    <div class="row">
            <div class="col xl12 panel" >
                <h4>{{ title }}</h4>
                <div class="left" v-for="breadcrumb in breadcrumbs" v-bind:key="breadcrumb.route">
                    <router-link :to="breadcrumb.route">{{ breadcrumb.name }}</router-link>&nbsp;>&nbsp;
                </div>
                {{ title }}
            </div>
    </div>
</template>
<style scoped>
.row {
  background-color: #eeeeee;
  height: 120px;
}
</style>
<script>
export default {
  props: {
    /** * Array that holdes the navigation history to print breadcrumbs */
    history: Array,
  },
  computed: {
    /** * As title we put the last element in the history */
    title() {
      return this.history[this.history.length - 1].name;
    },
    /** * We return all history to be linked except for the last (current) element */
    breadcrumbs() {
      return this.history.slice(0, this.history.length - 1);
    },
  },
};
</script>
<style>
a {
  color: var(--primary-dark-color);
}
</style>

